// extracted by mini-css-extract-plugin
export default {"root":"style_root__qComV","mark":"style_mark__MsG2I","top":"style_top__wsr+r","bottom":"style_bottom__Nw1dt","spades":"style_spades__NbnjR","clubs":"style_clubs__qU3cc"};